import { sendVisitorAllocatedVariations, sendVisitorExposedVariations } from './index';
import { FS_FORCED_VARIATIONS, FS_IS_QA_MODE_ENABLED, FS_QA_ASSISTANT_SCRIPT_TAG_ID, FS_VARIATIONS_FORCED_ALLOCATION, FS_VARIATIONS_FORCED_UNALLOCATION, SDK_INFO } from '../../../enum/FlagshipConstant';
import { INTERNAL_EVENTS } from '../type';
export function onQaAssistantReady(visitorVariationState) {
    if (visitorVariationState.visitorVariations) {
        sendVisitorAllocatedVariations(visitorVariationState);
    }
    if (visitorVariationState.exposedVariations) {
        sendVisitorExposedVariations(visitorVariationState);
    }
}
export function render(forcedReFetchFlags = false) {
    if (SDK_INFO.name === 'TypeScript') {
        window.location.reload();
    }
    const triggerRenderEvent = new CustomEvent(INTERNAL_EVENTS.FsTriggerRendering, { detail: { forcedReFetchFlags } });
    window.dispatchEvent(triggerRenderEvent);
}
export function onQaAssistantClose({ config, func, visitorVariationState }) {
    config.isQAModeEnabled = false;
    sessionStorage.removeItem(FS_IS_QA_MODE_ENABLED);
    if (func) {
        window.removeEventListener('message', func);
    }
    document.getElementById(FS_QA_ASSISTANT_SCRIPT_TAG_ID)?.remove();
    visitorVariationState.forcedVariations = {};
    render();
}
export function onApplyForcedVariations({ value, visitorVariationState }) {
    const sessionForcedVariations = sessionStorage.getItem(FS_FORCED_VARIATIONS);
    let forcedVariations = {};
    try {
        forcedVariations = JSON.parse(sessionForcedVariations || '{}');
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing sessionForcedVariations', error);
    }
    forcedVariations = {
        ...forcedVariations,
        ...value
    };
    sessionStorage.setItem(FS_FORCED_VARIATIONS, JSON.stringify(forcedVariations));
    visitorVariationState.forcedVariations = forcedVariations;
    render();
}
export function onResetForcedVariations(visitorVariationState) {
    sessionStorage.removeItem(FS_FORCED_VARIATIONS);
    visitorVariationState.forcedVariations = {};
    render();
}
function removeForcedVariation(keys, visitorVariationState) {
    const sessionForcedVariations = sessionStorage.getItem(FS_FORCED_VARIATIONS);
    let forcedVariations = {};
    try {
        forcedVariations = JSON.parse(sessionForcedVariations || '{}');
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error parsing sessionForcedVariations', error);
    }
    keys.forEach((key) => {
        delete forcedVariations[key];
    });
    sessionStorage.setItem(FS_FORCED_VARIATIONS, JSON.stringify(forcedVariations));
    visitorVariationState.forcedVariations = forcedVariations;
}
export function onRemoveForcedVariation({ keys, visitorVariationState }) {
    removeForcedVariation(keys, visitorVariationState);
    visitorVariationState.shouldForceRender = true;
    render(true);
}
export function onVariationsForcedAllocation({ value, visitorVariationState }) {
    sessionStorage.setItem(FS_VARIATIONS_FORCED_ALLOCATION, JSON.stringify(value));
    const variationsForcedAllocation = visitorVariationState.variationsForcedAllocation || {};
    const diffVariationKeys = Object.keys(variationsForcedAllocation).filter((key) => !(key in value));
    if (diffVariationKeys.length > 0) {
        removeForcedVariation(diffVariationKeys, visitorVariationState);
    }
    visitorVariationState.variationsForcedAllocation = value;
    visitorVariationState.shouldForceRender = true;
    render(true);
}
export function onVariationsForcedUnallocation({ value, visitorVariationState }) {
    sessionStorage.setItem(FS_VARIATIONS_FORCED_UNALLOCATION, JSON.stringify(value));
    visitorVariationState.variationsForcedUnallocation = value;
    visitorVariationState.shouldForceRender = true;
    render(true);
}
